/* eslint-disable no-prototype-builtins */
import { MessageBox, Notification } from 'element-ui'
import axios from 'axios'
import 'babel-polyfill'

// localStorage 键名
const TOKEN_KEY = 'pre_token'

// 共享 axios 实例（带请求/响应拦截器）
const http = axios.create({
  timeout: 30000
})

// 请求拦截器：自动从 localStorage 注入 Authorization Bearer
http.interceptors.request.use(config => {
  const token = window.localStorage && window.localStorage.getItem(TOKEN_KEY)
  if (token) {
    config.headers = config.headers || {}
    config.headers['Authorization'] = `Bearer ${token}`
  }
  return config
})

// 401 统一处理：清 token，保留 id 跳回 code 页（hash mode）
// 供拦截器、XHR / 裸 axios 上传、lbp_common 兜底等所有 401 路径调用
function handleUnauthorized () {
  try {
    if (window.localStorage) {
      window.localStorage.removeItem(TOKEN_KEY)
    }
    // hash mode 下 id 存在 location.hash 里，形如 #/xxx?id=abc
    const hash = (window.location && window.location.hash) || ''
    const match = hash.match(/[?&]id=([^&]+)/)
    const id = match ? decodeURIComponent(match[1]) : ''
    const targetHash = id ? `#/code?id=${encodeURIComponent(id)}` : '#/code'
    if (hash === targetHash) {
      // 已经在目标页，赋值不触发导航，用 reload 刷新状态
      window.location.reload()
    } else {
      window.location.hash = targetHash
    }
  } catch (e) { /* ignore */ }
}

// 响应拦截器：401 走统一处理
http.interceptors.response.use(
  res => res,
  error => {
    if (error.response && error.response.status === 401) {
      handleUnauthorized()
    }
    return Promise.reject(error)
  }
)

function IsPC () {
  var userAgentInfo = navigator.userAgent
  var Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
  var flag = true
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false
      break
    }
  }
  return flag
}

function showAlert (msg) {
  let textdata =
    '<div id="js_dialog"><div class="weui-mask"></div><div class="weui-dialog"><div class="weui-dialog__hd"><strong class="weui-dialog__title">错误</strong></div><div class="weui-dialog__bd">' +
    msg +
    '</div><div class="weui-dialog__ft"><div id="confirmBtn" onclick="document.getElementById(\'alert_div\').remove()" class="weui-dialog__btn weui-dialog__btn_primary">确定</div></div></div></div>'
  let body = document.getElementById('app')
  let div = document.createElement('div')
  div.id = 'alert_div'
  div.innerHTML = textdata
  body.appendChild(div)
}

const errorCallback = function (error) {
  if (!error.response) return

  // 可以通过 window.ENV 来区分desktop\mobile
  switch (error.response.status) {
    case 422: {
      let errorList = ''
      for (let field in error.response.data) {
        if (!error.response.data.hasOwnProperty(field)) continue
        for (let i in error.response.data[field]) {
          if (!error.response.data[field].hasOwnProperty(i)) continue
          errorList += error.response.data[field][i]
        }
      }
      MessageBox.alert(errorList, '参数格式错误', {
        confirmButtonText: '确定',
        type: 'error'
      })
      break
    }
    case 401: {
      if (IsPC()) {
        MessageBox({
          title: '错误',
          message: '登录已失效，请重新输入验证码进入！',
          type: 'error'
        })
      } else {
        window.alert = showAlert('登录已失效，请重新输入验证码进入！')
      }
      break
    }
    case 403: {
      if (IsPC()) {
        MessageBox({
          title: '错误',
          message:
            "对不起，您无权限访问此功能!<br/>找<strong style='font-weight:bold;'><a href='https://applink.feishu.cn/client/bot/open?appId=cli_9f4460138eb1500e'>IT机器人</a></strong>寻求帮助",
          dangerouslyUseHTMLString: true,
          type: 'error'
        })
      } else {
        window.alert = showAlert('对不起，您无权限访问此功能!')
      }
      break
    }
    case 404: {
      if (IsPC()) {
        MessageBox({
          title: '错误',
          message: '对不起，您要查看的页面不存在，请联系系统管理员!',
          type: 'error'
        })
      } else {
        window.alert = showAlert('对不起，您要查看的页面不存在，请联系系统管理员!')
      }

      break
    }
    case 413: {
      if (IsPC()) {
        MessageBox({
          type: 'error',
          message: '上传文件大小超过系统限制,上传失败',
          title: '错误'
        })
      } else {
        window.alert = showAlert('上传文件大小超过系统限制,上传失败')
      }
      break
    }
    case 500: {
      if (IsPC()) {
        MessageBox({
          title: '错误',
          message: '对不起，系统内部出现错误，请稍候再试，或联系信息系统部!',
          type: 'error'
        })
      } else {
        window.alert = showAlert('对不起，系统内部出现错误，请稍候再试，或联系信息系统部!')
      }

      break
    }
    default: {
      Notification.error({
        title: '网络错误',
        message: '请联系系统管理员!'
      })
    }
  }
}

// 处理接口返回值
function handleCallback (responseData, success, failure) {
  if (responseData.code === 0) {
    success(responseData.data, responseData.meta || '', responseData.message || '')
  } else {
    failure(responseData.code, responseData.message)
  }
}

function get (url, params) {
  return http
    .get(url, {
      params: params
    })
    .catch(err => {
      errorCallback(err)
    })
}

// 对get请求封装
function httpGet (url, params, success, failure, httpFail) {
  return http
    .get(url, {
      params: params
    })
    .then(res => {
      handleCallback(res.data, success, failure)
    })
    .catch(error => {
      errorCallback(error)
      httpFail && httpFail(error)
    })
}

// 对post请求封装
function httpPost (url, params, success, failure, httpFail) {
  return http
    .post(url, params)
    .then(res => {
      handleCallback(res.data, success, failure)
    })
    .catch(error => {
      errorCallback(error)
      httpFail && httpFail(error)
    })
}

// 使用post获取到数据流,下载文件
function httpPostDownload (url, params, fileName = '导出.xlsx', success, failure, httpFail) {
  return http({
    url: url,
    method: 'post',
    headers: {
      'Content-Type': 'text/html; charset=UTF-8'
    },
    responseType: 'blob', // 一定要写
    params: params
  })
    .then(res => {
      // 因为无法从return获取错误信息,此处提示自定义提示语，从header中获取
      let message = res.headers['message'] ? res.headers['message'] : ''
      if (message) {
        handleCallback({ code: -1, message: decodeURIComponent(escape(message)) }, success, failure)
        return
      }
      const blob = new Blob([res.data]) // 处理文档流
      const elink = document.createElement('a')
      elink.download = fileName
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href) // 释放URL 对象
      document.body.removeChild(elink)
    })
    .catch(error => {
      errorCallback(error)
      httpFail && httpFail(error)
    })
}

function httpPut (url, params, success, failure, httpFail) {
  return http
    .put(url, params)
    .then(res => {
      handleCallback(res.data, success, failure)
    })
    .catch(error => {
      errorCallback(error)
      httpFail && httpFail(error)
    })
}

function httpDelete (url, params, success, failure, httpFail) {
  return http
    .delete(url, params)
    .then(res => {
      handleCallback(res.data, success, failure)
    })
    .catch(error => {
      errorCallback(error)
      httpFail && httpFail(error)
    })
}

export default {
  http,           // 暴露共享 instance，供需要直接 axios 调用的地方使用（如 uploader）
  TOKEN_KEY,
  handleUnauthorized, // 供 XHR / 裸 axios 上传等 401 路径调用
  handleCallback,
  errorCallback,
  httpGet,
  httpPost,
  httpPostDownload,
  httpPut,
  httpDelete,
  get
}



// WEBPACK FOOTER //
// ./src/assets/js/util.js